/**
 * @param object
 * @return {string}
 */
export function getObjectClassName(object) {
    return object.toString().split ('(' || /s+/)[0].split (' ' || /s+/)[1];
}

/**
 * @param property
 * @return {string}
 */
export function parsePropertyName(property) {
    return property.replace(/^_/, '');
}